import { Button } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { usePensionNameValue } from "@/shared/client";
import { type SpecialDmaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Grid, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { useState } from "react";
import { SpecialPreviewCard } from "../preViewCard";

export const OtherSpecial = ({ specials }: SpecialDmaxInfoResponse) => {
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const [startIndex, setStartIndex] = useState(0);

    const { isMobile, isLaptop } = MEDIAS();

    const visibleCount = isMobile ? 1 : 3;

    const maxIndex = Math.max(0, specials.length - visibleCount);
    const visibleItems = specials.slice(startIndex, startIndex + visibleCount);

    const handlePrev = () => {
        setStartIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
        setStartIndex((prev) => Math.min(prev + 1, maxIndex));
    };

    return (
        <Center position="relative" w="100%">
            <Center as="section" w="100%" maxW="1280px">
                <Flex flexDir="column" gap={isMobile ? "48px" : "96px"} p={isLaptop ? "0 20px" : "0"} w="100%">
                    <Flex gap="40px">
                        {!isMobile && <Box w="2px" bg="#6b6b6b" />}
                        <Flex flexDir="column" gap="24px">
                            <Text {...FONT("cormorant", isMobile ? 32 : 56, 700, 1.2)}>OTHER</Text>
                            <Text
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${pensionName.kor}의 특별함`) }}
                                {...FONT("pretendard", isMobile ? 12 : 18, 300, 1.4)}
                            />
                        </Flex>
                    </Flex>

                    <Box position="relative" w="100%">
                        <Grid templateColumns={`repeat(${visibleCount}, 1fr)`} gap="32px" w="100%">
                            {visibleItems.map((special) => (
                                <SpecialPreviewCard key={special.special_idx} specialData={special} />
                            ))}
                        </Grid>

                        <Button
                            roundType="none"
                            borderType="none"
                            background="blackAlpha.400 !important"
                            color="#fff"
                            p="0 !important"
                            w="80px"
                            h="80px !important"
                            position="absolute"
                            top="30%"
                            left="0"
                            zIndex="2"
                            onClick={handlePrev}
                            isDisabled={startIndex === 0}
                        >
                            <Text fontSize="36px" className="material-icons-outlined">
                                arrow_back_ios
                            </Text>
                        </Button>
                        <Button
                            roundType="none"
                            borderType="none"
                            background="blackAlpha.400 !important"
                            color="#fff"
                            p="0 !important"
                            w="80px"
                            h="80px !important"
                            position="absolute"
                            top="30%"
                            right="0"
                            zIndex="2"
                            onClick={handleNext}
                            isDisabled={startIndex >= maxIndex}
                        >
                            <Text fontSize="36px" className="material-icons-outlined">
                                arrow_forward_ios
                            </Text>
                        </Button>
                    </Box>
                </Flex>
            </Center>
        </Center>
    );
};
